import getWithToken from './base/get-with-token'

const getSettingReceiveMailAlert = getWithToken(`/list-receive-email-alert`)

export default getSettingReceiveMailAlert
